import React, { useEffect, useState, useCallback } from 'react';
import Modal from "react-bootstrap/Modal";
import { toast } from 'react-toastify';
import LeaseApiService from '../../services/apiService';
import { useTranslation } from 'react-i18next';

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;
const MAX_FILE_SIZE_MB = 200;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

const ImagesList = ({ attachments, setDeletedFiles, deletedFiles, setAttachments, createEmptyRow }) => {
    const { t } = useTranslation();
    const apiService = new LeaseApiService();

    // Attachment
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewType, setPreviewType] = useState("");
    const [previewImage, setPreviewImage] = useState(null);
    let readOnly = false
    // Attachment Functions
    const handleFileSelect = useCallback((file, id) => {
        if (file && file.size > MAX_FILE_SIZE_BYTES) {
            toast.error(t('common.fileTooLarge', `File exceeds the ${MAX_FILE_SIZE_MB}MB limit and was not added.`));
            return;
        }
        setAttachments((prev) => {
            const updated = prev.map((row) =>
                row.id === id
                    ? {
                        ...row,
                        file,
                        fileName: file.name,
                        isNew: true,   // ✅ mark new
                    }
                    : row
            );

            return [...updated, createEmptyRow()];
        });
    }, []);
    const handleRemarkChange = (id, value) => {
        setAttachments((prev) =>
            prev.map((row) =>
                row.id === id ? { ...row, remarks: value } : row
            )
        );
    };
    const handleDelete = async (row) => {
        if (!row.isNew) {
            setDeletedFiles((prev) => [...prev, row.fileName]);
            // const fileparams = new URLSearchParams();
            // fileparams.append('filePath', row?.filePath);
            // const imgRes = await apiService.deleteParameter('DELETE_FILE', `?${fileparams.toString()}`);
        }

        setAttachments((prev) => prev.filter((item) => item.id !== row.id));
    };
    const handleView = (row) => {
        if (!row) return;

        let fileUrl = "";
        let fileType = "";

        if (row.isNew) {
            fileUrl = URL.createObjectURL(row.file);
            fileType = row.file?.type || "";
        } else {
            fileUrl = row.fullUrl;

            const extension = row.fileName?.split(".").pop()?.toLowerCase();

            if (["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(extension)) {
                fileType = "image";
            } else if (extension === "pdf") {
                fileType = "application/pdf";
            } else if (["txt", "csv"].includes(extension)) {
                fileType = "text/plain";
            } else {
                fileType = "other";
            }
        }

        setPreviewImage(fileUrl);
        setPreviewType(fileType);
        setPreviewModal(true);
    };
    return (
        <div className=''>
            <table className="table table-bordered">
                <thead className="dynoTable">
                    <tr>
                        <th>{t('common.fileName')}</th>
                        <th>{t('common.remarks')}</th>
                        <th>{t('common.upload')}</th>
                        <th>{t('common.view')}</th>
                        <th>{t('common.delete')}</th>
                    </tr>
                </thead>
                <tbody>
                    {attachments.map((row) => (
                        <tr key={row.id}>
                            <td>
                                <input disabled value={row.fileName} className="form-control" />
                            </td>

                            <td>
                                <input
                                    disabled={readOnly}
                                    value={row.remarks}
                                    className="form-control"
                                    onChange={(e) =>
                                        handleRemarkChange(row.id, e.target.value)
                                    }
                                />
                            </td>

                            <td>
                                <input
                                    type="file"
                                    hidden
                                    id={`file-${row.id}`}
                                    onChange={(e) =>
                                        handleFileSelect(e.target.files[0], row.id)
                                    }
                                />
                                <button
                                    className="mainbtn"
                                    onClick={() =>
                                        document.getElementById(`file-${row.id}`).click()
                                    }
                                >
                                    {t('common.upload')}
                                </button>
                            </td>

                            <td>
                                <button
                                    className="mainbtnRed"
                                    disabled={!row.fileName}
                                    onClick={() => handleView(row)}
                                >
                                    {t('common.view')}
                                </button>
                            </td>

                            <td>
                                <button
                                    className="mainbtnSecondary"
                                    onClick={() => handleDelete(row)}
                                >
                                    {t('common.delete')}
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <Modal
                show={previewModal}
                size="lg"
                onHide={() => setPreviewModal(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{t('common.preview')}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ minHeight: "500px" }}>
                    {!previewImage ? null : previewType.startsWith("image") ? (
                        <img
                            src={previewImage}
                            alt="preview"
                            style={{ width: "100%" }}
                        />
                    ) : previewType === "application/pdf" ? (
                        <iframe
                            src={previewImage}
                            title="PDF Preview"
                            width="100%"
                            height="600px"
                            style={{ border: "none" }}
                        />
                    ) : previewType.startsWith("text") ? (
                        <iframe
                            src={previewImage}
                            title="Text Preview"
                            width="100%"
                            height="600px"
                            style={{ border: "none" }}
                        />
                    ) : (
                        <div className="text-center">
                            <p>{t('unitMaster.imagesFields.previewNotAvailable')}</p>

                            <a
                                href={previewImage}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-primary"
                            >
                                {t('unitMaster.imagesFields.openFile')}
                            </a>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setPreviewModal(false)}
                    >
                        {t('common.close')}
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ImagesList